/** @graphql cc **/

import gql from 'graphql-tag';

export const CreateSpaceQuery = gql`
	query CreateSpaceQuery {
		user: confluence_atlassianUser(current: true) {
			id
			confluence {
				operations {
					operation
				}
			}
		}
	}
`;
